import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { CartItemStatus } from "@/shared/utils/interfaces";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

interface Body {
  order: OrderV2;
  status: CartItemStatus;
  kitchenScreenId: string;
  kitchen_prep_time_in_seconds?: number;
}

const useCartItemStatusMutation = (customBranch?: number) => {
  const { t } = useTranslation();
  const id = useBranchId();
  const branch = customBranch || id;

  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.create"));
    },
    mutationFn: ({ order, status, kitchenScreenId, ...body }: Body) =>
      patch(
        `/internal/secure/pos/v1/cart/items/kitchen/status/${branch}/${order.order_information.item_id}/${status}/${kitchenScreenId}`,
        body
      ),
  });
  return mutation;
};

export default useCartItemStatusMutation;
